module.exports = __webpack_public_path__ + "static/media/15.3a654bcd.jpg";